angular.module('unica_invitation_group.invitation_group_services')

.factory('InvitationGroupEditService', function ($http, getBaseApiURL) {

	var InvitationGroupEditService = {};

	InvitationGroupEditService.update = function (invitationGroupData)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-group/update/' + invitationGroupData.id,
			data: invitationGroupData
		}).then(function(result) {

			if ( result ) {
				return result.data.invitationGroup;
			}

		});
	};

	InvitationGroupEditService.updateFilter = function (notificationId, searchData)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-group/update-filter/' + notificationId,
			data: {
				filter: JSON.stringify( searchData )
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.invitationGroup;
			}

		});
	};

	return InvitationGroupEditService;
});